export const loginMparticleEvent = (customerid) => {
  if (window?.mParticle?.Identity?.getCurrentUser().isLoggedIn()) {
    return;
  }
  const identityRequest = {
    userIdentities: {
      customerid,
    },
  };
  const identityCallback = function (result) {
    if (result.getUser()) {
    }
  };
  window.mParticle.Identity.login(identityRequest, identityCallback);
};

export const logoutMparticleEvent = () => {
  const identityCallback = function (result) {
    console.log("succesfully loggedout", result);
  };
  window.mParticle.Identity.logout({}, identityCallback);
};
